// openEHR RM model — BMM package org.openehr.rm.composition.content
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import { LOCATABLE } from "../common/archetyped.ts";

/**
 * Abstract ancestor of all concrete content types.
 */
export abstract class CONTENT_ITEM extends LOCATABLE {
}
